// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"5db52e25","547":"316898f5","614":"19e1bbbb"}[chunkId] + ".chunk.js";
};